// .category-submenu-text要素を全て取得する
const eyAccordionItems = document.querySelectorAll('.category-item');
const eyCategorySubmenu = document.querySelectorAll('.category-submenu');
let eyOpenedIndex = null;

// 各アイテムにクリックイベントを追加する
eyAccordionItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    if (item.classList.contains('active')) {
      eyCategorySubmenu[index].style.height = 0;
      item.classList.toggle('active');
      eyCategorySubmenu[index].classList.toggle('active');
      openedIndex = null; // 閉じる場合にはopenedIndexをnullにする
    } else {
      if (eyOpenedIndex !== null) {
        // 他のcategory-submenuが開かれている場合、閉じる
        eyCategorySubmenu[openedIndex].style.height = 0;
        eyAccordionItems[openedIndex].classList.toggle('active');
        eyCategorySubmenu[openedIndex].classList.toggle('active');
      }
      eyCategorySubmenu[index].style.height = 'auto';
      eyCategorySubmenu[index].classList.toggle('active');
      let itemHeight = eyCategorySubmenu[index].offsetHeight;
      eyCategorySubmenu[index].style.height = itemHeight + 'px';
      eyCategorySubmenu[index].animate([{ height: 0 }, { height: itemHeight + 'px' }], {
        duration: 300,
      });
      item.classList.toggle('active');
      openedIndex = index;
    }
  });
});